import { AccessContext, valid } from "lego-gui-lib";
import { get, has } from "lodash";
import split from "lodash/split";
import { mainStore } from "../../core/mainStore";
import { OutputType } from "../tree/treeBlock/treeBlockOutputsDataSource";

export const serviceProfileAllows = (
  ctx: AccessContext,
  flag: string
): boolean => {
  return get(ctx, `data.serviceProfile.config.${flag}`) === true;
};

export const sanHasCalendar = (ctx: AccessContext): boolean =>
  has(ctx, "data.calendarRef");

// Used for output form, where output is to be determined by User selection and proper form field to be selected based on that type.
// Checks for outputType emptiness to determine if used in form context and prevents rendering multiple field types in OutputLabel.
export const isOutputFormOfType = (
  outputType: OutputType,
  outputTypeFromCtx: OutputType
): boolean => {
  return (
    mainStore.treeBlockOutputs.isFormOutputTypeOfType(outputType) &&
    outputHasType(outputTypeFromCtx, undefined)
  );
};

// Used for output that is set on an existing block in graph.
export const outputHasType = (
  outputTypeFromCtx: OutputType,
  outputType: OutputType | undefined
): boolean => {
  return outputTypeFromCtx === outputType;
};

export const NumericRangeFromLessIncTo = valid(
  v => {
    if (v) {
      const [from, to] = split(v, "-");
      return parseInt(from) <= parseInt(to);
    }
    return true;
  },
  "hns:tree:treeBlock:output:numericCode:fromLowerThanTo",
  '"From" must be lower or equal "To"'
);

export const NumericRangeFromSameLengthAsTo = valid(
  v => {
    if (v) {
      const [from, to] = split(v, "-");
      return from.length === to.length;
    }
    return true;
  },
  "hns:tree:treeBlock:output:numericCode:fromSameLengthAsTo",
  '"From" must have the same number of digits as "To"'
);

export const AdvancedConditionMax14Digits = valid(
  (v: any, values: any, meta: any) => v.length < 15,
  "hns:tree:treeBlock:output:advancedConditions:invalidFormat",
  "Invalid format, up to 14 digits expected"
);
